const htmlBody = document.querySelector('#viewEveryoneMailing').querySelector('div[name=body]');
import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';

export default {

  cleanContainer() {
    htmlBody.innerHTML = '';
  },

  getElement(item, index) {

  return `<div class = "card-mail-adresssees row p-1 " mID=${item.id} numReq=${item.numRequest}> 
            <h4  class="p-1 ml-1 mr-3" mID=${item.id}  numReq=${item.numRequest}>${item.numRequest}</h4>
            <div class="column p-0 m-0"  mID=${item.id} numReq=${item.numRequest}>
              <small   numReq=${item.numRequest} mID=${item.id}>${item.name}</small>
              <b  numReq=${item.numRequest}  mID=${item.id}>${item.mail}</b>
            </div>
            
          </div>`;
  },

  drawDataInContainer(servAvnswer) {
    this.cleanContainer();
    // htmlBody.innerHTML = '<div class="row p-1">';
    if(servAvnswer)
      servAvnswer.forEach((item, index) => htmlBody.insertAdjacentHTML('beforeend', this.getElement(item, index)));
    // htmlBody.insertAdjacentHTML('beforeend', '</div>');
  },

  drawMarkupInContainer(markup) {
    htmlBody.insertAdjacentHTML('beforeend', markup);
  },

};
